import { Checkbox, Form, Input, TextArea } from 'components/Form';
import { Link } from 'components/Link';
import { RichText } from 'components/slices/RichText';
import { Turnstile } from 'components/Turnstile';
import { useAppContext } from 'shared/useAppContext';
import { useState } from 'react';

export const ContactForm = () => {
  const { formSettings } = useAppContext();
  const successMessage = formSettings.data.contact_thanks_message;
  const termsLink = formSettings.data.terms_link;

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [turnstileKey, setTurnstileKey] = useState(0);

  const onSubmit = async (data) => {
    setError(null);
    if (!turnstileToken) {
      setError('Bevestig eerst dat je geen robot bent.');
      return;
    }
    const { error } = await fetch('/api/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...data,
        turnstileToken,
      }),
    }).then((r) => r.json());

    if (error) {
      setError(error);
      setTurnstileToken(null);
      setTurnstileKey((key) => key + 1);
    } else {
      setSuccess(true);
    }
  };

  if (success) {
    return <RichText content={successMessage} />;
  }

  return (
    <Form onSubmit={onSubmit} error={error}>
      <Input name="firstName" label="Voornaam" required />
      <Input name="name" label="Achternaam" required />
      <Input name="email" type="email" label="E-mailadres" required />
      <Input name="phone" type="tel" label="Telefoonnummer" />
      <Input name="subject" label="Onderwerp" required />
      <TextArea name="message" label="Bericht" required />
      <Checkbox name="wantsNewsletter" label="Aanmelden voor de nieuwsbrief" />
      <Checkbox
        name="acceptsTerms"
        label={
          <span>
            Ik ga akkoord met de{' '}
            <Link field={termsLink} target="_blank">
              voorwaarden
            </Link>
            .
          </span>
        }
        required
      />
      <Turnstile
        key={turnstileKey}
        action="contact"
        onToken={setTurnstileToken}
      />
    </Form>
  );
};
